import type { ParsedUrlQuery } from 'querystring';
import { LOCATION_CHANGE } from 'connected-react-router';
import type { SagaIterator } from 'redux-saga';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { SOURCE_PARAM } from '@members/on-demand-modal/constants';
import {
  closeModal,
  getModalNameFromLocation,
  ModalActionType,
  openModal,
} from './redux';
import { MODAL_PARAM } from './urls';

export const modalCloseSaga = function* (
  action: any, // Using any type to unblock type erorrs on router.replace calls,
): SagaIterator {
  const queryParams = { ...action.payload.router.query };

  yield call(action.payload.router.push, {
    query: toQueryParamsWithoutModal(queryParams, action.payload.additionalParams),
  });
};

export const modalOpenSaga = function* (): SagaIterator {
  const urlModal = yield select(getModalNameFromLocation);
  if (urlModal) {
    yield put(openModal(urlModal));
  }
};

export const toQueryParamsWithoutModal = (
  queryParams: ParsedUrlQuery,
  additionalModalParams: string[] = [],
) => {
  const paramsToOmit = [MODAL_PARAM, SOURCE_PARAM, ...additionalModalParams];
  const filteredParams = Object.keys(queryParams)
    .filter(param => !paramsToOmit.includes(param))
    .reduce((obj, param) => {
      return {
        ...obj,
        [param]: queryParams[param],
      };
    }, {});

  return filteredParams;
};

export const modalWatcherSaga = function* () {
  yield takeEvery(ModalActionType.Close, modalCloseSaga);
  yield takeEvery(LOCATION_CHANGE, modalOpenSaga);
};

export const x = closeModal;
export const y = openModal;
